import React, { useState, useEffect } from "react";
import Sidebar from "../Constant/sidebar";
import TopBar from "../Constant/TopBar";
import Footer from "../Constant/Footer";
import * as userActions from "../../actions/index";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import moment from "moment";
import "moment-timezone";
import { connect } from "react-redux";
import { DateRangePicker } from "mui-daterange-picker";
const StaffLoginActivity = (props) => {
  const [logData, setLogsData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [action, setAction] = useState("ALL");
  const [isLoading, setIsLoading] = useState(true);

  const current = new Date();
  const getMonday = (d) => {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(d.setDate(diff));
  };
  const monday = getMonday(current);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const [start_date, setStart_date] = useState(moment(monday).format("YYYY-MM-DD"));
  const [end_date, setEnd_date] = useState(moment(sunday).format("YYYY-MM-DD"));
  const [open, setOpen] = useState(false);

  const showDatePicker = () => setOpen(!open);
  const toggle = () => setOpen(!open);
  const setDateRange = (range) => {
    setStart_date(moment(range.startDate).format("YYYY-MM-DD"));
    setEnd_date(moment(range.endDate).format("YYYY-MM-DD"));
    toggle();
    setPage(1);
  };

  const row_limit = [
    { value: 10, label: 10 },
    { value: 25, label: 25 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
    { value: 250, label: 250 },
    { value: 500, label: 500 },
  ];

  const GetLoginActivityLogs = async () => {
    setIsLoading(true);
    props
      .onGetLoginActivityLogs(page, limit, search, start_date, end_date, action)
      .then((response) => {
        if (response && response.success === true) {
          const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
          const timezone = user_info?.user_school?.timezone;
          const allData = response.data || [];
          setCount(response.total || 0);

          const mapped = allData.map((item) => ({
            ...item,
            formatted_date: moment(item.created_date)
              ?.tz(timezone)
              ?.format("MMMM Do YYYY, h:mm a"),
          }));

          setLogsData(mapped);
        } else {
          setLogsData([]);
          setCount(0);
        }
      })
      .catch((error) => {
        console.error("Error fetching login activity logs:", error);
        setLogsData([]);
        setCount(0);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    GetLoginActivityLogs();
    // eslint-disable-next-line
  }, [page, limit, start_date, end_date, action]);

  useEffect(() => {
    setIsLoading(true);
    const delayDebounceFn = setTimeout(() => {
      GetLoginActivityLogs();
    }, 800);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line
  }, [search]);

  const skeletons = new Array(10).fill(null);

  return (
    <>
      <div
        id="kt_body"
        className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
      >
        <div className="d-flex flex-column flex-root">
          <div className="page d-flex flex-row flex-column-fluid">
            <Sidebar />
            <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
              <TopBar />
              <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                <div className="post d-flex flex-column-fluid" id="kt_post">
                  <div id="kt_content_container" className="container-fluid">
                    <div className="school-edit-form">
                      <div className="" id="StaffLoginActivity">
                        <div className="card-body p-0">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="card tabs-outer">
                                <div className="card-header position-relative py-0 details-bg">
                                  <h2 className="card-title m-0">Staff Login Activity</h2>
                                </div>
                                <div className="card-body position-relative">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="d-flex justify-content-between align-items-center pb-5 px-2 border-bottom border-1 border-secondary">
                                        <div className="card-toolbar gap-3 d-flex align-items-center">
                                          <div className="d-flex align-items-center justify-content-between export-out">
                                            <div className="d-flex align-items-center position-relative">
                                              <span className="svg-icon svg-icon-1 position-absolute ms-4">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="24"
                                                  viewBox="0 0 24 24"
                                                >
                                                  <rect
                                                    opacity="0.5"
                                                    x="17.0365"
                                                    y="15.1223"
                                                    width="8.15546"
                                                    height="2"
                                                    rx="1"
                                                    transform="rotate(45 17.0365 15.1223)"
                                                    fill="currentColor"
                                                  ></rect>
                                                  <path
                                                    d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                                                    fill="currentColor"
                                                  ></path>
                                                </svg>
                                              </span>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm w-350px ps-12 search-out fs-6"
                                                placeholder="Search "
                                                style={{ background: "transparent" }}
                                                onChange={(e) => {
                                                  setSearch(e.target.value);
                                                  setPage(1);
                                                }}
                                              />
                                            </div>
                                          </div>
                                          {/* Date Range Picker */}
                                          <div className="col">
                                            <div className="position-relative" style={{ width: "350px" }} onClick={() => showDatePicker()}>
                                              <span className="position-absolute apply_adhoc_leave_date_and_time">
                                                <i className="far fa-calendar-alt mt-2px"></i>
                                              </span>
                                              <input
                                                type="text"
                                                placeholder="Large text"
                                                value={start_date + "   to   " + end_date}
                                                className="form-control bg-transparent"
                                                style={{ cursor: "pointer" }}
                                              />
                                            </div>
                                            <div className="date-picker position-absolute">
                                              <DateRangePicker
                                                open={open}
                                                toggle={toggle}
                                                onChange={(range) => setDateRange(range)}
                                                closeOnClickOutside={true}
                                              />
                                            </div>
                                          </div>
                                          {/* Action Filter */}
                                          <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            defaultValue={{ value: "ALL", label: "All" }}
                                            options={[
                                              { value: "ALL", label: "All" },
                                              { value: "LOGIN", label: "Logins" },
                                              { value: "LOGOUT", label: "Logouts" },
                                            ]}
                                            onChange={(selected) => {
                                              setAction(selected.value);
                                              setPage(1);
                                            }}
                                          />
                                        </div>
                                        <span className="text-secondary">
                                          <strong>Date & Time</strong>
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-sm-12">
                                      {/* Skeleton */}
                                      {isLoading &&
                                        skeletons.map((_, index) => (
                                          <div
                                            className="row py-3 px-2 border-bottom align-items-center"
                                            key={index}
                                          >
                                            <div className="col-9">
                                              <div className="d-flex justify-content-start align-items-center">
                                                <div className="me-3">
                                                  <p className="placeholder-glow" style={{ marginBottom: 0 }}>
                                                    <span
                                                      className="placeholder bg-dark rounded-circle"
                                                      style={{ width: "30px", height: "30px" }}
                                                    ></span>
                                                  </p>
                                                </div>
                                                <div>
                                                  <p className="placeholder-glow" style={{ marginBottom: 0 }}>
                                                    <span
                                                      className="placeholder bg-dark rounded-3"
                                                      style={{ width: "400px" }}
                                                    ></span>
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-3 text-end">
                                              <p className="placeholder-glow" style={{ marginBottom: 0 }}>
                                                <div className="d-flex justify-content-end align-items-center">
                                                  <span className="bg-light-info px-2 py-1 rounded-3 placeholder col-9 bg-dark"></span>
                                                </div>
                                              </p>
                                            </div>
                                          </div>
                                        ))}

                                      {/* No Data */}
                                      {!isLoading && logData.length === 0 && (
                                        <div className="row py-3 px-2 border-bottom">
                                          <div className="col-12 text-center text-muted py-4">
                                            No staff login activity found
                                          </div>
                                        </div>
                                      )}

                                      {/* Data Rows */}
                                      {!isLoading &&
                                        logData.length > 0 &&
                                        logData.map((item, index) => (
                                          <div
                                            className="row py-3 px-2 border-bottom"
                                            key={item.activity_log_uuid || index}
                                          >
                                            <div className="col-9">
                                              <div className="d-flex justify-content-start align-items-center">
                                                <div className="me-3">
                                                  <img
                                                    alt="avatar"
                                                    src={item.avatar || "/assets/media/school-logo.png"}
                                                    className="rounded-circle"
                                                    style={{ width: "30px", height: "30px", objectFit: "cover" }}
                                                    onError={(e) => { e.target.src = "/assets/media/school-logo.png"; }}
                                                  />
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <strong>{item.user_name}</strong>
                                                  {item.action === "LOGIN" ? (
                                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M8.76796 0C8.6476 0.000469272 8.52851 0.0246406 8.41749 0.0711347C8.30647 0.117629 8.2057 0.185535 8.12092 0.270976C8.03615 0.356416 7.96903 0.457718 7.9234 0.569098C7.87778 0.680477 7.85454 0.799752 7.85501 0.920113C7.85595 1.16195 7.95244 1.39362 8.12345 1.56463C8.29446 1.73564 8.52612 1.83213 8.76796 1.83307H13.646C13.9507 1.83307 14.1741 2.0493 14.1741 2.35399V13.8966C14.1741 14.2013 13.9507 14.4175 13.646 14.4175H8.76796C8.6476 14.418 8.52851 14.4422 8.41749 14.4887C8.30647 14.5352 8.2057 14.6031 8.12092 14.6885C8.03614 14.774 7.96903 14.8753 7.9234 14.9866C7.87778 15.098 7.85454 15.2173 7.85501 15.3377C7.85595 15.5795 7.95244 15.8112 8.12345 15.9822C8.29446 16.1532 8.52612 16.2497 8.76796 16.2506H13.646C14.9345 16.2506 16 15.1851 16 13.8966V2.35399C16 1.06547 14.9345 0 13.646 0H8.76796ZM7.44149 3.64645C7.199 3.65027 6.96791 3.75005 6.79884 3.92392C6.71461 4.0105 6.64832 4.11287 6.60379 4.22516C6.55926 4.33744 6.53736 4.45742 6.53936 4.5782C6.54135 4.69897 6.5672 4.81816 6.61542 4.92891C6.66364 5.03967 6.73327 5.13979 6.82032 5.22354L8.86462 7.21235H0.912963C0.671122 7.2133 0.439456 7.30978 0.268447 7.48079C0.0974391 7.6518 0.00095029 7.88347 7.01361e-06 8.12531C-0.000463831 8.24567 0.0227766 8.36495 0.0684022 8.47633C0.114028 8.58771 0.181145 8.68901 0.265921 8.77445C0.350697 8.85989 0.451471 8.9278 0.562491 8.97429C0.67351 9.02078 0.792601 9.04496 0.912963 9.04542H8.85926L6.82032 11.0342C6.64669 11.2031 6.54697 11.4339 6.54294 11.676C6.53892 11.9182 6.63092 12.1521 6.79885 12.3267C6.88259 12.4137 6.98272 12.4834 7.09347 12.5316C7.20422 12.5798 7.32342 12.6057 7.44419 12.6077C7.56497 12.6097 7.68495 12.5878 7.79723 12.5432C7.90951 12.4987 8.01189 12.4324 8.09847 12.3482L11.7521 8.78227C11.8396 8.69688 11.9091 8.59485 11.9566 8.48217C12.0041 8.3695 12.0286 8.24847 12.0286 8.1262C12.0286 8.00393 12.0041 7.88289 11.9566 7.77022C11.9091 7.65754 11.8396 7.55551 11.7521 7.47012L8.09846 3.91139C8.01201 3.82585 7.9094 3.75837 7.79661 3.71288C7.68382 3.6674 7.5631 3.64481 7.44149 3.64645Z" fill="#009EF7"/>
                                                    </svg>
                                                  ) : (
                                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M7.07664 4.30784C7.56043 4.30784 7.95602 3.91225 7.95602 3.42847V1.75874H14.2419V14.9451H7.95602V12.8353C7.95602 12.3515 7.56043 11.9559 7.07664 11.9559C6.59286 11.9559 6.19727 12.3515 6.19727 12.8353L6.19809 15.8245C6.19809 16.3082 6.59368 16.7038 7.07747 16.7038H15.1212C15.605 16.7038 16.0006 16.3082 16.0006 15.8245L15.9998 0.879371C15.9998 0.39559 15.6042 0 15.1204 0L7.07664 0.000824147C6.59286 0.000824147 6.19727 0.396415 6.19727 0.880195V3.42928C6.19809 3.91223 6.59368 4.30784 7.07664 4.30784Z" fill="#009EF7"/>
                                                      <path d="M3.91144 12.1321C4.08699 12.2639 4.26336 12.3521 4.48258 12.3521C4.74631 12.3521 4.96636 12.2639 5.1419 12.0447C5.4493 11.6928 5.40563 11.1217 5.05372 10.8143L3.25211 9.23108H11.164C11.6478 9.23108 12.0434 8.83549 12.0434 8.35171C12.0434 7.86792 11.6478 7.47233 11.164 7.47233H3.25211L5.09821 5.88997C5.45013 5.58257 5.49381 5.0106 5.1864 4.65953C4.87899 4.30761 4.30702 4.26394 3.95594 4.57134L0.351921 7.69239C0.131865 7.86794 0 8.08799 0 8.35171C0 8.61544 0.131865 8.83549 0.307403 9.01103L3.91144 12.1321Z" fill="#009EF7"/>
                                                    </svg>
                                                  )}
                                                  <span>{item.action_label}{item.details ? ` ${item.details}` : ""}</span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-3 text-end">
                                              <div className="d-flex justify-content-end align-items-center">
                                                <span className="bg-light-info px-2 py-1 rounded-3 text-secondary">
                                                  {item.formatted_date}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                    </div>
                                  </div>

                                  {/* Pagination and Limit */}
                                  {!isLoading && logData.length > 0 && (
                                    <div className="d-flex justify-content-between mt-4">
                                      <Select
                                        menuPlacement="top"
                                        className="basic-single"
                                        classNamePrefix="select"
                                        defaultValue={row_limit[0]}
                                        name="color"
                                        options={row_limit}
                                        onChange={(event) => {
                                          setLimit(event.value);
                                          setPage(1);
                                        }}
                                      />
                                      <Stack spacing={1}>
                                        <Pagination
                                          count={Math.ceil(count / limit)}
                                          page={page}
                                          onChange={(event, value) => setPage(value)}
                                          color="primary"
                                        />
                                      </Stack>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {};
}
const mapDispatchToProps = {
  onGetLoginActivityLogs: userActions.GetLoginActivityLogs,
};
export default connect(mapStateToProps, mapDispatchToProps)(StaffLoginActivity);
